import { Translate, useFormController } from '@dreryk/react-common';
import {
   AutoLayout,
   componentsTranslationKeys,
   DatePicker,
   dayValidator,
   StyledMaxWidth,
} from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../translations';
import { StatisticsCode } from '../list/StatisticsListTable.types';

import { GenerateStatisticsFormBean, GenerateStatisticsFormController } from './GenerateStatisticsForm.types';
import { generateStatisticsFormOptionsLabel } from './GenerateStatisticsForm.utils';

type GenerateStatisticsFormRenderProps = Pick<GenerateStatisticsFormController, 'handleSubmit' | 'formState'>;

type GenerateStatisticsFormProps = {
   readonly code: StatisticsCode;
   readonly children: (renderProps: GenerateStatisticsFormRenderProps) => JSX.Element;
};

export const GenerateStatisticsForm = (props: GenerateStatisticsFormProps): JSX.Element => {
   const { register, handleSubmit, formState, watch } = useFormController<GenerateStatisticsFormBean>(undefined);
   const label = generateStatisticsFormOptionsLabel(props.code);

   const { from: dateFrom, to: dateTo } = watch(['from', 'to']);

   return (
      <AutoLayout as={'form'} $direction={'vertical'} $spacing={24}>
         <Translate>{label}</Translate>
         <AutoLayout as={'div'} $direction={'horizontal'} $spacing={24}>
            <StyledMaxWidth maxWidth={142}>
               <DatePicker
                  testId={'from'}
                  placeholder={componentsTranslationKeys.datePickerPlaceholder}
                  controller={register('from', { required: true })}
                  label={statisticsTranslationKeys.modal.from}
                  dayValidators={[dayValidator.dayAfterToday(), dayValidator.dayAfterReferenceDay(dateTo)]}
               />
            </StyledMaxWidth>
            <StyledMaxWidth maxWidth={142}>
               <DatePicker
                  testId={'to'}
                  placeholder={componentsTranslationKeys.datePickerPlaceholder}
                  controller={register('to')}
                  label={statisticsTranslationKeys.modal.to}
                  dayValidators={[dayValidator.dayAfterToday(), dayValidator.dayBeforeReferenceDay(dateFrom)]}
               />
            </StyledMaxWidth>
         </AutoLayout>

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </AutoLayout>
   );
};
